import styled from "styled-components";

import { media } from "../../../../styles/media";

export const ManagerFormStyles = styled.div`
  .flexContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .inputContainer {
      width: 48%;
    }

    ${media.maxMobile`
      flex-direction: column;
      align-items: stretch;
      gap: 12px;

      .inputContainer {
        width: 100%;
      }
    `}
  }

  .input {
    margin-top: 2px;
  }

  .checkboxContainer {
    display: flex;
    align-items: center;
    margin-top: 15px;
    gap: 24px;

    ${media.maxMobile`
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    `}
  }

  .branchesSection {
    margin-bottom: 20px;
    margin-top: 2px;
  }

  .buttonContainer {
    display: flex;
    justify-content: flex-end;
  }
`;
